import { Injectable, defineInjectable, Component, NgModule } from '@angular/core';
import { Subject } from 'rxjs';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';

const _c0 = function (a0, a1) { return [a0, a1]; };
function AlertNotificationComponent_li_1_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 2)(1, "div", 3)(2, "div", 4)(3, "p", 5);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "p", 6);
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelementStart(7, "div", 7)(8, "p", 8);
    ɵngcc0.ɵɵlistener("click", function AlertNotificationComponent_li_1_Template_p_click_8_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r4); const alert_r1 = restoredCtx.$implicit; const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r3.close(alert_r1.id)); });
    ɵngcc0.ɵɵtext(9, "\u2716");
    ɵngcc0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const alert_r1 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(3, _c0, alert_r1.type, ctx_r0.position + "-animate"));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(alert_r1 == null ? null : alert_r1.title);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(alert_r1 == null ? null : alert_r1.message);
} }
class AlertService {
    constructor() {
        this.position = 'bottom-right';
        this.interval = 5000;
        this.autodismiss = true;
        this.alerts = [];
        this.positionUpdated = new Subject();
        this.alertUpdated = new Subject();
    }
    /**
     * @return {?}
     */
    getPosition() {
        return this.position;
    }
    /**
     * @param {?} position
     * @return {?}
     */
    setPosition(position) {
        this.position = position;
        console.log('set' + this.position);
        this.positionUpdated.next(this.position);
    }
    /**
     * @return {?}
     */
    getPositionUpdateListner() {
        return this.positionUpdated.asObservable();
    }
    /**
     * @return {?}
     */
    getAlerts() {
        return this.alerts;
    }
    /**
     * @param {?} newId
     * @param {?} newType
     * @param {?} newTitle
     * @param {?} newMessage
     * @return {?}
     */
    push(newId, newType, newTitle, newMessage) {
        this.alerts.push({
            id: newId,
            title: newTitle,
            message: newMessage,
            type: newType.toLowerCase()
        });
        this.alertUpdated.next(this.alerts);
        if (this.autodismiss) {
            setTimeout((/**
             * @return {?}
             */
            () => {
                this.removeAlert(newId);
            }), this.interval);
        }
    }
    /**
     * @param {?} id
     * @return {?}
     */
    removeAlert(id) {
        /** @type {?} */
        const updatedAlerts = [];
        this.alerts.forEach((/**
         * @param {?} alert
         * @return {?}
         */
        alert => {
            if (alert.id !== id) {
                updatedAlerts.push(alert);
            }
        }));
        this.alerts = updatedAlerts;
        this.alertUpdated.next(this.alerts);
    }
    /**
     * @return {?}
     */
    getAlertUpdateListner() {
        return this.alertUpdated.asObservable();
    }
    /**
     * @param {?} time
     * @return {?}
     */
    setInterval(time) {
        this.interval = time;
    }
    /**
     * @param {?} dismiss
     * @return {?}
     */
    setAutoDismiss(dismiss) {
        this.autodismiss = dismiss;
    }
}
AlertService.ɵfac = function AlertService_Factory(t) { return new (t || AlertService)(); };
AlertService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: AlertService, factory: AlertService.ɵfac, providedIn: 'root' });
/** @nocollapse */ AlertService.ngInjectableDef = defineInjectable({ factory: function AlertService_Factory() { return new AlertService(); }, token: AlertService, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AlertService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AlertNotificationComponent {
    /**
     * @param {?} alertService
     */
    constructor(alertService) {
        this.alertService = alertService;
        this.alerts = [];
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.position = this.alertService.getPosition();
        this.alerts = this.alertService.getAlerts();
        this.positionSub = this.alertService.getPositionUpdateListner().subscribe((/**
         * @param {?} data
         * @return {?}
         */
        data => {
            this.position = data;
        }));
        this.alertsSub = this.alertService.getAlertUpdateListner().subscribe((/**
         * @param {?} alerts
         * @return {?}
         */
        alerts => {
            this.alerts = alerts;
        }));
    }
    /**
     * @param {?} id
     * @return {?}
     */
    close(id) {
        this.alertService.removeAlert(id);
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.positionSub.unsubscribe();
    }
}
AlertNotificationComponent.ɵfac = function AlertNotificationComponent_Factory(t) { return new (t || AlertNotificationComponent)(ɵngcc0.ɵɵdirectiveInject(AlertService)); };
AlertNotificationComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: AlertNotificationComponent, selectors: [["alert-notification"]], decls: 2, vars: 2, consts: [[1, "alert", 3, "ngClass"], ["class", "shadow", 3, "ngClass", 4, "ngFor", "ngForOf"], [1, "shadow", 3, "ngClass"], [1, "flex-container"], [1, "content"], [1, "title"], [1, "message"], [1, ""], [1, "close", 3, "click"]], template: function AlertNotificationComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "ul", 0);
        ɵngcc0.ɵɵtemplate(1, AlertNotificationComponent_li_1_Template, 10, 6, "li", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ctx.position);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.alerts);
    } }, dependencies: [ɵngcc1.NgClass, ɵngcc1.NgForOf], styles: [".top-left[_ngcontent-%COMP%]{top:0;left:0;padding-left:0;margin-left:1rem}.bottom-left[_ngcontent-%COMP%]{bottom:0;left:0;padding-left:0;margin-left:1rem}.top-right[_ngcontent-%COMP%]{top:0;right:0;margin-right:1rem}.bottom-right[_ngcontent-%COMP%]{bottom:0;right:0;margin-right:1rem}.alert[_ngcontent-%COMP%]{position:absolute;list-style:none;font-family:Verdana,Tahoma,sans-serif;overflow:hidden;z-index:10000000000!important;padding:.4rem 0}.alert[_ngcontent-%COMP%]   .info[_ngcontent-%COMP%]{background:#33b5e5;color:#fff;border-color:#09c}.alert[_ngcontent-%COMP%]   .success[_ngcontent-%COMP%]{background:#07c152;color:#fff;border-color:#007e33}.alert[_ngcontent-%COMP%]   .warning[_ngcontent-%COMP%]{background:#f44;color:#fff;border-color:#c00}.alert[_ngcontent-%COMP%]   .simple[_ngcontent-%COMP%]{background:#3d3d3d;color:#fff;border-color:#000}.alert[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{margin:.5rem 0;padding:.5rem 1rem;border-radius:2px;background:#057db7;color:#fff}.alert[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{margin:0;font-size:14px}.alert[_ngcontent-%COMP%]   .message[_ngcontent-%COMP%]{margin:0;font-size:11px}.alert[_ngcontent-%COMP%]   .close[_ngcontent-%COMP%]{margin:1rem .1rem 1rem 2rem;cursor:pointer;color:#fff;font-size:14px}.alert[_ngcontent-%COMP%]   .close[_ngcontent-%COMP%]:hover{color:rgba(255,255,255,.57)}.alert[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]{flex:1;min-width:180px}.shadow[_ngcontent-%COMP%]{box-shadow:0 0 4px 1px #a9a4a4!important}.flex-container[_ngcontent-%COMP%]{display:flex;align-items:center;flex-direction:row}.bottom-right-animate[_ngcontent-%COMP%], .top-right-animate[_ngcontent-%COMP%]{position:relative;-webkit-animation:.4s animateright;animation:.4s animateright}.bottom-left-animate[_ngcontent-%COMP%], .top-left-animate[_ngcontent-%COMP%]{position:relative;-webkit-animation:.4s animateright;animation:.4s animateleft}@-webkit-keyframes animateright{from{right:-300px;opacity:0}to{right:0;opacity:1}}@keyframes animateright{from{right:-300px;opacity:0}to{right:0;opacity:1}}@-webkit-keyframes animateleft{from{left:-300px;opacity:0}to{left:0;opacity:1}}@keyframes animateleft{from{left:-300px;opacity:0}to{left:0;opacity:1}}"] });
/** @nocollapse */
AlertNotificationComponent.ctorParameters = () => [
    { type: AlertService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AlertNotificationComponent, [{
        type: Component,
        args: [{ selector: 'alert-notification', template: "<ul class=\"alert\" [ngClass]=\"position\">\r\n  <li class=\"shadow\" [ngClass]=\"[alert.type, position+'-animate']\" *ngFor=\"let alert of alerts; index as i\">\r\n    <div class=\"flex-container\">\r\n      <div class=\"content\">\r\n        <p class=\"title\">{{ alert?.title }}</p>\r\n        <p class=\"message\">{{ alert?.message }}</p>\r\n      </div>\r\n      <div class=\"\">\r\n        <p class=\"close\" (click)=\"close(alert.id)\">&#10006;</p>\r\n      </div>\r\n    </div>\r\n  </li>\r\n</ul>\r\n", styles: [".top-left{top:0;left:0;padding-left:0;margin-left:1rem}.bottom-left{bottom:0;left:0;padding-left:0;margin-left:1rem}.top-right{top:0;right:0;margin-right:1rem}.bottom-right{bottom:0;right:0;margin-right:1rem}.alert{position:absolute;list-style:none;font-family:Verdana,Tahoma,sans-serif;overflow:hidden;z-index:10000000000!important;padding:.4rem 0}.alert .info{background:#33b5e5;color:#fff;border-color:#09c}.alert .success{background:#07c152;color:#fff;border-color:#007e33}.alert .warning{background:#f44;color:#fff;border-color:#c00}.alert .simple{background:#3d3d3d;color:#fff;border-color:#000}.alert li{margin:.5rem 0;padding:.5rem 1rem;border-radius:2px;background:#057db7;color:#fff}.alert .title{margin:0;font-size:14px}.alert .message{margin:0;font-size:11px}.alert .close{margin:1rem .1rem 1rem 2rem;cursor:pointer;color:#fff;font-size:14px}.alert .close:hover{color:rgba(255,255,255,.57)}.alert .content{flex:1;min-width:180px}.shadow{box-shadow:0 0 4px 1px #a9a4a4!important}.flex-container{display:flex;align-items:center;flex-direction:row}.bottom-right-animate,.top-right-animate{position:relative;-webkit-animation:.4s animateright;animation:.4s animateright}.bottom-left-animate,.top-left-animate{position:relative;-webkit-animation:.4s animateright;animation:.4s animateleft}@-webkit-keyframes animateright{from{right:-300px;opacity:0}to{right:0;opacity:1}}@keyframes animateright{from{right:-300px;opacity:0}to{right:0;opacity:1}}@-webkit-keyframes animateleft{from{left:-300px;opacity:0}to{left:0;opacity:1}}@keyframes animateleft{from{left:-300px;opacity:0}to{left:0;opacity:1}}"] }]
    }], function () { return [{ type: AlertService }]; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AlertModule {
}
AlertModule.ɵfac = function AlertModule_Factory(t) { return new (t || AlertModule)(); };
AlertModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: AlertModule });
AlertModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [BrowserModule,
        CommonModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AlertModule, [{
        type: NgModule,
        args: [{
                declarations: [AlertNotificationComponent],
                imports: [
                    BrowserModule,
                    CommonModule
                ],
                exports: [AlertNotificationComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AlertModule, { declarations: function () { return [AlertNotificationComponent]; }, imports: function () { return [BrowserModule,
        CommonModule]; }, exports: function () { return [AlertNotificationComponent]; } }); })();
class Alert {
}

export { Alert, AlertModule, AlertNotificationComponent, AlertService };

